import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vbn-browser-fail',
  templateUrl: './browser-fail.component.html',
  styleUrls: ['./browser-fail.component.scss']
})
export class BrowserFailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
